// Regles de visibilite/temporalite d'un evenement, partagees entre
// AppContext (filtre carte/liste) et les features qui ont besoin de la meme
// notion d' "evenement secret" ou "a venir" (ex: section organisateur de la
// fiche evenement) — source unique plutot qu'une resolution dupliquee par
// consommateur.

export function normalizeEventVisibility(value) {
  return String(value || "").trim().toLowerCase().replace(/-/g, "_");
}

export function isSecretEvent(event = {}) {
  return normalizeEventVisibility(event?.visibility) === "link_only";
}

export function resolveEventDate(event = {}) {
  if (event?.startsAt) {
    const startsAtDate = new Date(event.startsAt);
    if (!Number.isNaN(startsAtDate.getTime())) {
      return startsAtDate;
    }
  }

  if (!event?.date) {
    return null;
  }

  const safeTime = String(event.startTime || "20:00");
  const parsedDate = new Date(`${event.date}T${safeTime}:00`);

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  return parsedDate;
}

export function isUpcomingEvent(event = {}, nowDate = new Date()) {
  // Même règle que le backend : une sortie disparaît dès que sa date de début
  // est passée, même si elle n'est pas terminée (décision du 2026-10-03).
  const startsAtDate = resolveEventDate(event);

  if (!startsAtDate) {
    // Si la date est absente/invalide, on conserve l'event
    // pour eviter de masquer des sorties potentiellement valides.
    return true;
  }

  return startsAtDate.getTime() >= nowDate.getTime();
}
